"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";

export default function NotFound() {
  const t = useTranslations("not_found");
  return (
    <div className="flex flex-col items-center bg-white text-black justify-center min-h-screen w-full">
      <h1 className="text-5xl mb-4">{t("title")}</h1>
      <p className="text-lg mb-8">{t("message")}</p>
      <Link href="/" className="px-6 py-3 bg-red-600 text-white rounded-md hover:bg-black transition duration-300">
        {t("home_button")}
      </Link>
    </div>
  );
}
